import { mapProps } from 'recompose'

import themed from '@/ui/Theme/themed'
import DatePicker from './DatePicker'

const DatePickerRedux = mapProps(
  ({ meta: { touched, error } = {}, input: { onBlur, value, ...inputProps }, ...props }) => {
    return {
      errorText: touched && error,
      computableFormat: 'YYYY-MM-DD HH:mm:ss',
      format: 'MM-DD-YYYY',
      date: value,
      onBlur: e => onBlur(), // Prevent redux form from updating with onBlur event target
      ...inputProps,
      ...props,
    }
  },
)(DatePicker)

const DatePickerThemed = themed(DatePickerRedux)

export default DatePicker
export { DatePickerThemed as DatePicker }



// WEBPACK FOOTER //
// ./ui/DatePicker/index.js